module.exports = __webpack_public_path__ + "media/images/logo_eim-97723317.png";